import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PageComponentModule } from '../../../../cms-structure';
import { I18nModule } from '../../../../core/i18n';
import { GenericLinkModule, MegamenuListItemsModule } from '../../../../shared';
import { MenuServicesItemsModule } from '../menu-services/menu-services-item/menu-services-item.module';
import { MobileNavigationServicesComponent } from './mobile-navigation-services.component';

@NgModule({
  declarations: [MobileNavigationServicesComponent],
  imports: [
    NzIconModule,
    CommonModule,
    NgbCollapseModule,
    GenericLinkModule,
    PageComponentModule,
    I18nModule,
    MegamenuListItemsModule,
    MenuServicesItemsModule,
  ],
  providers: [],
  exports: [MobileNavigationServicesComponent],
})
export class MobileNavigationServicesModule {}
